import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import { Radio, DatePicker } from 'antd';

const { RangePicker } = DatePicker;
const dateFormat = 'DD-MM-YY HH:mm';
let today = dayjs();
let startTime = dayjs().startOf('day').valueOf();
let endTime = dayjs().valueOf();

const DaysPickerNew = ({
  selectedDateRange, onChangeSelectedDateRange, 
  onChangeDatePickerType,
  pickerOptions=['day', 'week','month', 'custom'],
  maxDuration=93}) => {
  startTime = selectedDateRange ? selectedDateRange[0] : startTime;
  endTime = selectedDateRange ? selectedDateRange[1] : endTime;
  today = selectedDateRange ? dayjs(selectedDateRange[0]) : today;
  // const [datePickerType, setDatePickerType] = useState('day');
  const [datePickerType, setDatePickerType] = useState(pickerOptions[0]);
  const [selectedDate, setSelectedDate] = useState(today);
  const [range, setRange] = useState([dayjs(startTime), dayjs(endTime)]);
  const [now, setNow] = useState(dayjs());
  const pickerRef = useRef();
  const rangeRef = useRef();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(dayjs());
    }, 30 * 1000);

    return () => clearInterval(intervalId);
  },[]);

  useEffect(() => {
    let newSelectedDate;
    let newStartEndDateTime = {};
    switch(datePickerType){
      case 'day':
      case 'week':
      case 'month':
        newSelectedDate = selectedDate.startOf(datePickerType);
        newStartEndDateTime = getStartEndTime(selectedDate);
        pickerRef?.current?.focus();
        break;
      case 'custom':
        newSelectedDate = range[0].startOf(datePickerType);
        const endDate = range[1].endOf(datePickerType);
        newStartEndDateTime = {
          start: newSelectedDate.startOf("minute"),
          end: endDate.isSame(now, 'day') ? now : endDate.endOf("day")
        }
        rangeRef?.current?.focus();
        break;
      default:
        break;
    }
    setRange([newStartEndDateTime.start, newStartEndDateTime.end])
    onChangeSelectedDateRange([newStartEndDateTime.start?.valueOf(), newStartEndDateTime.end?.valueOf()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datePickerType])

  const disabledDate = (current) => {
    const today = dayjs().startOf('day');
    const startDateDisable = dayjs().subtract(maxDuration, 'days').startOf('day');
    if (datePickerType === 'month'){
      return current && (current.isAfter(today, 'month') || current.isBefore(startDateDisable, 'month'));
    } else {
      return current && (current.isAfter(today, 'day') || current.isBefore(startDateDisable, 'day'));
    }
  };

  const dateCustomFormat = (value) => {
    let endTime = value.isSame(now, 'day') || value.isAfter(now, 'day') ? 
      dayjs(now).format(dateFormat) : dayjs(value).endOf('day').format(dateFormat);
    return(
    `${dayjs(value).startOf('day').format(dateFormat)} to ${endTime}`);
  }

  const rangeCustomFormat = (value) => {
    let startDateTime, endDateTime;
    if (datePickerType === "week") {
      startDateTime = value.startOf("week").startOf("day");
      while (disabledDate(startDateTime)) {
        startDateTime = startDateTime.add(1, 'day');
      }
      const endOfWeek = value.endOf("week").endOf("day");
      endDateTime = endOfWeek.isAfter(now, 'day') ? now : value.endOf("week").endOf("day")
    } else if (datePickerType === "month") {
      let startOfMonth = value.startOf("month").startOf("day");
      let endOfMonth = value.endOf("month").endOf("day");
      // if (disabledDate(startOfMonth)) {
      //   startDateTime = startOfMonth.add(endOfMonth.isAfter(now, 'day') ? -1 : 1, 'month').startOf('month');
      //   endOfMonth = endOfMonth.add(endOfMonth.isAfter(now, 'day') ? -1 : 1, 'month').endOf("month").endOf();
      // }
      const startDateDisable = dayjs().subtract(maxDuration, 'days').startOf('day');
      startDateTime = startOfMonth.isBefore(startDateDisable, 'day') ? startDateDisable : startOfMonth;
      endDateTime = endOfMonth.isAfter(now, 'day') ? now : endOfMonth;
    }
    return (`${startDateTime?.format(dateFormat)} to ${endDateTime?.format(dateFormat)}`);  
  }

  const rangePickerCustomFormat = (value) =>{
    return `${value.format(dateFormat)}`
  }

  const handleDateChange = (date) => {
    if (date) {
      let startDate = date.startOf(datePickerType);
      const { start, end } = getStartEndTime(startDate);
      setSelectedDate(start);
      setRange([start, end])
      onChangeSelectedDateRange([start.valueOf(), end.valueOf()]);
    }
  }

  const handleDateRangeChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const startDate = dates[0].startOf(datePickerType);
      const endDate = dates[1].endOf(datePickerType);
      const end = endDate.isSame(now, 'day') ? now : endDate.endOf("day");
      setSelectedDate(startDate);
      setRange([startDate.startOf("minute"), end])
      onChangeSelectedDateRange([startDate.startOf("minute").valueOf(), end.valueOf()]);
    }
  };

  const handleDateTypeChange = (e) => {
    setDatePickerType(e.target.value);
    onChangeDatePickerType(e.target.value);
  };


  const getStartEndTime = (date) => {
    const startDateDisable = dayjs().subtract(maxDuration, 'days').startOf('day');
    if (datePickerType === "day") {
      const end = date.isSame(now, 'day') ? now : date.endOf("day").endOf("minute")
      return {
        start: date.startOf("day").startOf("minute"),
        end,
      };
    } else if (datePickerType === "week") {
      const startOfWeek = date.startOf("week").startOf("day");
      const endOfWeek = date.endOf("week").endOf("day");
      const end = endOfWeek.isAfter(now, 'day') ? now : date.endOf("week").endOf("day")
      return {
        start: startOfWeek.isBefore(startDateDisable, 'day') ? startDateDisable : startOfWeek.startOf("minute"),
        end,
      };
    } else if (datePickerType === "month") {
      const startOfMonth = date.startOf("month").startOf("day");
      const endOfMonth = date.endOf("month").endOf("day");
      return {
        start: startOfMonth.isBefore(startDateDisable, 'day') ? startDateDisable : startOfMonth.startOf("minute"),
        end: endOfMonth.isAfter(now, 'day') ? now : date.endOf("month").endOf("day"),
      };
    }
  };

  const footerMessage = () => {
    let msg = '';
    if (datePickerType === 'day') {
      msg = 'Select a date within the last 3 months';
    } else if (datePickerType === 'week'){
      msg = 'Select a week within the last 3 months';
    } else if (datePickerType === 'month'){
      msg = 'Select a full month within the last 3 months';
    } else {
      msg = 'Select From & To Dates, within the last 3 months';
    }
    return msg;
  }

return (
    <>{pickerOptions.length ?
    <div className="day-picker-comp">
      <div>
        <div style={{maxWidth: '260px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {datePickerType === 'custom' ?
            <RangePicker
              defaultValue={[dayjs(selectedDate, dateFormat), dayjs(selectedDate, dateFormat)]}
              ref={rangeRef}
              allowClear={false}
              value={range}   
              className="custom-range-picker"
              disabledDate={disabledDate}
              onChange={handleDateRangeChange}
              format={rangePickerCustomFormat}
              style={{width:'100%'}}
              separator={' to '}
              suffixIcon={null}
              renderExtraFooter={footerMessage}
            />
            :
            <DatePicker 
              ref={pickerRef}
              allowClear={false}
              value={selectedDate}
              picker={datePickerType}
              className="day-picker text-overflow"
              disabledDate={disabledDate}
              onChange={(handleDateChange)}
              format={datePickerType === 'day' ? dateCustomFormat : rangeCustomFormat}
              showWeek={false}
              style={{width:'100%'}}
              suffixIcon={null}
              renderExtraFooter={footerMessage}
            />
          }
        </div>
      </div>          
      <Radio.Group buttonStyle="solid" 
        onChange={handleDateTypeChange} 
        value={datePickerType}
        className='display-flex'
      >
        {pickerOptions.map((picker, i) => (
            <Radio.Button key={i} className='day-filter-btn' value={picker}>{`${picker.charAt(0).toUpperCase()+picker.slice(1)}`}</Radio.Button>
        ))}
          {/* <Radio.Button className='day-filter-btn' value="day">Day</Radio.Button>
          <Radio.Button value="week">Week</Radio.Button>
          <Radio.Button value="month">Month</Radio.Button>
          <Radio.Button value="custom">Custom</Radio.Button> */}
      </Radio.Group>
    </div> 
    : null
    }
    </>
  );
};

export default DaysPickerNew;
